<template>
  <div id="app">
    <div class="somethingwrong">
      <b-alert
        variant="danger"
        dismissible
        :show="showErrorAlert"
        @dismissed="showErrorAlert = false"
      >
        <div
          v-html="errorMsg"
          class="errorMsg"
        ></div>
      </b-alert>
    </div>
    <div
      v-if="isLoading"
      class="loader"
    >
      <b-spinner
        v-if="loadingIcon == 'systemDefault'"
        class="spinner"
        variant="primary"
        label="Spinning"
      ></b-spinner>
      <b-spinner
        v-else-if="loadingIcon == 'ypbDefault'"
        class="spinner"
        variant="primary"
        label="Spinning"
      ></b-spinner>
      <b-img
        v-else
        class="assetUrlImage"
        :src="assetUrl"
      ></b-img>
    </div>
    <v-style v-if="lpStyle">{{ lpStyle }}</v-style>
    <div
      v-if="upperLandingPage"
      v-html="upperLandingPage"
    >
    </div>
    <embeddedForm
      v-bind:formId="render.formId"
      v-show="render.showed"
      v-bind:campaignId="render.campaignId"
      v-bind:techId="render.techId"
      v-bind:campaignName="render.campaignName"
      v-bind:wronglyTypedProtectCode="wronglyTypedProtectCode"
      v-bind:qrLink="qrLink"
      v-bind:formCode="render.formCode"
      v-bind:ipCountry="trackingInfo['ip-country']"
      v-bind:trackingInfo="trackingInfo"
      v-bind:campaignRetainSelectedLanguage="selectedLanguage"
      v-on:onTranslationLangSelected="onTranslationLanguageSelectedAction($event)"
      v-on:submit="onSubmitAction($event)"
      v-on:error="onErrorAction($event)"
      v-on:toggle="afterSubmitAction($event)"
      v-on:loadend="afterLoadAction($event)"
      ref="embeddedForm"
    ></embeddedForm>
    <div
      v-if="lowerLandingPage"
      v-html="lowerLandingPage"
    >
    </div>
    <div
      v-if="showThankYou"
      class="loader"
    >
      <p class="thankyou">Thank you!</p>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import uuid from "uuid";
import Analytics from "analytics";
import miniToastr from "mini-toastr";
import NodeGeocoder from "node-geocoder";
import VueNotifications from "vue-notifications";
import { apigClient } from "@/shared/api";
import { formBuilder } from "formBuilder";
import embeddedForm from "../custom-components/embedded-form";
import { switchContentsBasedOnScanCountry } from './helpers/scanHelperFunctions';

const Spinner = () => import("../shared/Spinner");
const analytics = Analytics({
  app: "analytic",
  debug: true,
  plugins: []
});
const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};
miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
const analyticState = analytics.getState();

Vue.use(VueNotifications, options);

export default {
  name: "Constructor",
  components: {
    formBuilder,
    Spinner,
    embeddedForm
  },
  data() {
    let techType = this.$route.params.techType
      ? this.$route.params.techType
      : "q";
    let uniqueId = this.$route.params.uniqueId;
    let companyId = this.$route.params.companyId;
    let referrerUrl = analyticState.page.url;
    return {
      lpStyle: null,
      upperLandingPage: null,
      lowerLandingPage: null,
      referrerUrl: referrerUrl,
      client_id: null,
      client_email: null,
      uniqueId: uniqueId,
      techType: techType,
      companyId: companyId,
      currentNode: null,
      campaignData: null,
      landingPageBuilderData: null,
      formContents: [],
      trackingInfo: {
        ["ip-latitude"]: null,
        ["ip-longitude"]: null,
        ["ip-address"]: null,
        ["user-agent"]: null,
        ["ip-city"]: null,
        ["ip-country"]: null,
        ["ip-state"]: null
      },
      render: {
        formId: "",
        formCode: "",
        campaignId: "",
        campaignName: "",
        techId: "",
        showed: false,
      },
      qrLink: '',
      wronglyTypedProtectCode: '',
      loginUserInfo: JSON.parse(localStorage.getItem("loginUserInfo")),
      disabled: true,
      isLoading: false,
      showThankYou: false,
      loadingIcon: "systemDefault",
      assetUrl: null,
      showErrorAlert: false,
      errorMsg: null,
      formStyle: "",
      isSubmitted: false,
      formRenderOptions: {
        formData: []
      },
      formMessage: null,
      formAction: null,
      fbBuilder: {},
      formId: null,
      uaipKey: null,
      geoMsgAllowed: null,
      geolocationDetectedMsg: null,
      geolocationUndetectedMsg: null,
      geolocationCountry: null,
      geolocationCity: null,
      geolocationLatitude: null,
      geolocationLongitute: null,
      selectedLanguage: null,
    };
  },
  updated: function () {
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been re-rendered
      const scanCountry = this.trackingInfo["geo-country"] && this.trackingInfo["geo-country"] !== '' ?
                      this.trackingInfo["geo-country"] : this.trackingInfo["ip-country"];
      switchContentsBasedOnScanCountry(scanCountry);
    });
  },
  created: function() {},
  mounted: function() {
    let that = this;
    that.isLoading = true;
    that.loadCampaignInfo().then((result) => {
      if(result === 'ok'){
        that.renderCampaign();
        that.isLoading = false;
        that.insertClientRecord(
          "accessedFromIP",
          that.trackingInfo["ip-address"],
          { "Time on page": "n/a" }
        );
        that.insertClientRecord("pageHit", that.referrerUrl, {
          "Time on page": "n/a"
        });
        return;
      }
    });
  },
  computed: {},
  methods: {
    loadCampaignInfo() {
      return new Promise(async (resolve, reject) => {
        let that = this;
        await that.getTrackingInfo();
        await that.geolocationProcess();
        await that.loadSession();
        
        let pathTemplate = that.techType == "q" ? "/full-campaigninfo" : "";
        let additionalParams =
          that.techType == "q"
            ? {
                queryParams: {
                  params: JSON.stringify({
                    client_id: that.client_id,
                    companyId: that.companyId,
                    qrCodeUniqueId: that.uniqueId,
                    trackingInfo: that.trackingInfo
                  })
                }
              }
            : {};
        apigClient
          .invokeApi({}, pathTemplate, "GET", additionalParams)
          .then(async function(result) {
            if (result.data) {
              if (
                !result.data.qr ||
                !result.data.segment ||
                !result.data.campaign ||
                !result.data.wallet
              ) {
                that.manageScanUrl();
                console.log(
                  "Some related campaign info for qr cannot be loaded. ",
                  result.data
                );
                that.errorMsg = "Something went wrong, nothing to render";
                that.showErrorAlert = true;
                that.isLoading = false;
                reject("error");
              } else {
                that.errorMsg = null;
                that.showErrorAlert = false;
                if (
                  result.data.scanRecordId &&
                  Object.keys(result.data.campaign).length > 0
                ) {
                  that.campaignData = result.data;
                  that.qrLink = that.campaignData.qr.qr_link;
                  if (
                    that.campaignData.campaign.pageLoader != null &&
                    that.campaignData.campaign.pageLoader != undefined &&
                    that.campaignData.campaign.pageLoader.pageLoaderIcon !=
                      null &&
                    that.campaignData.campaign.pageLoader.pageLoaderIcon.name ==
                      "mediaLibraryAsset"
                  ) {
                    that.loadingIcon = "mediaLibraryAsset";
                    that.assetUrl =
                      that.campaignData.campaign.pageLoader.assetUrl;
                  }
                  if (
                    that.campaignData.wallet &&
                    that.campaignData.wallet.walletType
                  ) {
                    that.manageScanUrl(that.campaignData.wallet.walletType);
                  }
                  that.showMessageOfGeoDetectingFromCampaign();

                  resolve("ok");
                } else {
                  reject("error");
                }
              }
            } else {
              console.log("Error From API Endpoint: " + result.data.message);
              that.errorMsg = "Something went wrong, nothing to render";
              that.showErrorAlert = true;
              that.isLoading = false;
              reject("error");
            }
          })
          .catch(function(result) {
            console.log("invokeAPI Error: " + result);
            that.errorMsg = "Something went wrong, nothing to render";
            that.showErrorAlert = true;
            that.isLoading = false;
            reject("error");
          });
      });
    },
    manageScanUrl(walletType = null) {
      let that = this;
      if (
        walletType == null ||
        walletType == "Demo" ||
        walletType == "Official Use"
      ) {
        history.pushState(null, null, "/" + that.techType);
      }
    },
    getGeolatlan(){
      let that = this;
      return new Promise((resolve) => {
        const getGeoCityCountry = (position) => {
          that.geolocationLatitude = position.coords.latitude;
          that.geolocationLongitude = position.coords.longitude;
          that.trackingInfo["geo-latitude"] = that.geolocationLatitude;
          that.trackingInfo["geo-longitude"] = that.geolocationLongitude;
          resolve('ok');
        }
        const hasError = (error) => {
          console.log(error.message);
          resolve('error');
        };
        const options = {
          enableHighAccuracy: true, //default: false, but if enable, it uses more power on device for gps
          maximumAge        : 30000, //maxiumumAge to return cached postion
          timeout           : 60000  //timeout miliseconds if user don't respond to allow or block to share location
        };
        navigator.geolocation.getCurrentPosition(getGeoCityCountry, hasError, options);
      });
    },
    getGeolocation() {
      let that = this;
      return new Promise( async(resolve) => {
        // const geocoder = NodeGeocoder({
        //   provider: "google",
        //   httpAdapter: "https", // Default
        //   apiKey: "AIzaSyBHuFnXcvRwI6SNmxF-1MsM36xQH0zoxbE", // for Mapquest, OpenCage, Google Premier
        //   formatter: "json" // 'gpx', 'string', ...
        // });
        try{
          const { 'geo-latitude' : geoLat, 'geo-longitude' : geoLon } = that.trackingInfo;
          if((geoLat && geoLat !== '') && (geoLon && geoLon !== '')) {
            
            // const geoInfoResult = await geocoder.reverse(
            //   { lat: that.geolocationLatitude, lon: that.geolocationLongitude });
            const axios = require("axios");
            const geoInfoResult = await axios({
              method: "get",
              url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${that.geolocationLatitude},${that.geolocationLongitude} 
                    &result_type=administrative_area_level_1&key=AIzaSyBHuFnXcvRwI6SNmxF-1MsM36xQH0zoxbE`,
              responseType: "json"
            });
            const addressComponents = geoInfoResult.data.results[0]['address_components'];

            // that.geolocationCity = geoInfoResult[0].administrativeLevels.level1long;
            // that.geolocationCountry = geoInfoResult[0].country;

            that.geolocationCity = addressComponents[0]['long_name'];
            that.geolocationCountry = addressComponents[1]['long_name'];

            that.trackingInfo["geo-city"] = that.geolocationCity;
            that.trackingInfo["geo-country"] = that.geolocationCountry;
            resolve("Fetched geolocation");
          } else {
            resolve("No Need to fetch geo city and country");
          }
        } catch(e) {
          console.log(e.message);
          resolve("Issue in fetching geolocation");
        }
      });
    },
    async geolocationProcess() {
      let that = this;
      if (navigator.geolocation) {
        console.log("Geolocation supported by this browser.");
        const geoLatLanResult = await that.getGeolatlan();
        if(geoLatLanResult === 'ok'){
          await that.getGeolocation();
        }
      } else {
        console.log("Geolocation not supported by this browser.");
      }
    },
    showMessageOfGeoDetectingFromCampaign(){
      let that = this;
      const campaignGeolocation = that.campaignData.campaign.geolocation;
      if (campaignGeolocation && campaignGeolocation.allowGeolocationMessage) {
        const { geolocationDetectedMsg, geolocationUndetectedMsg } = campaignGeolocation;
        const { 'geo-latitude' : geoLat, 'geo-longitude' : geoLon } = that.trackingInfo;
        if((geoLat && geoLat !== '') && (geoLon && geoLon !== '')) {
          if(geolocationDetectedMsg && geolocationDetectedMsg !== ''){
            that.showSuccessMsg({ message: geolocationDetectedMsg });
          }
        } else {
          if(geolocationUndetectedMsg && geolocationUndetectedMsg !== ''){
            that.showErrorMsg({ message: geolocationUndetectedMsg });
          }
        }
      }
    },
    async getTrackingInfo() {
      let that = this;
      const axios = require("axios");
      const result = await axios({
        method: "get",
        url: "https://freegeoip.app/json/",
        responseType: "json"
      });
      if (result.data) {
        that.trackingInfo["ip-latitude"] = result.data.latitude;
        that.trackingInfo["ip-longitude"] = result.data.longitude;
        that.trackingInfo["ip-address"] = result.data.ip;
        that.trackingInfo["user-agent"] = navigator.userAgent;
        that.trackingInfo["ip-city"] = result.data.city;
        that.trackingInfo["ip-country"] = result.data.country_name;
        that.trackingInfo["ip-state"] = result.data.region_name;
        that.trackingInfo["geo-latitude"] = null;
        that.trackingInfo["geo-longitude"] = null;
        that.trackingInfo["geo-city"] = null;
        that.trackingInfo["geo-country"] = null;
      }
    },
    loadSession() {
      //scan session control logic
      this.uaipKey =
        this.trackingInfo["user-agent"] + this.trackingInfo["ip-address"];
      if (localStorage.getItem(this.uaipKey) !== null) {
        console.log("session for this ip and device existing");
      } else {
        localStorage.setItem(this.uaipKey, uuid.v4());
      }
      this.client_id = localStorage.getItem(this.uaipKey);
      // session expire when...
    },
    async renderCampaign() {
      let that = this;
      if (
        that.campaignData.campaign &&
        that.campaignData.campaign.nodes.length > 1 &&
        that.campaignData.campaign.links.length >= 1
      ) {
        // get walletSegmentNode
        let segmentSourceNode = that.campaignData.campaign.nodes.find(
          n => n.nodeClass == "walletSegments"
        );

        let toNodeId = segmentSourceNode.to;
        let toNode = that.campaignData.campaign.nodes.find(
          n => n.id == toNodeId
        );
        // checking firstNode is Form or not
        let isFirstNodeContentType = toNode.formData.title == "Content";
        if (
          isFirstNodeContentType &&
          toNode.formData.contentSelectValue.contentType == "form"
        ) {
          let formId = toNode.formData.contentSelectValue.id;
          //let form = that.formContents.find(form => form.id == formId);
          that.render.formId = formId;
          that.render.campaignId = that.campaignData.campaign.id;
          that.render.campaignName = that.campaignData.campaign.campaignName;
          that.render.techId = that.campaignData.qr.techId;
          that.currentNode = toNode;
          that.$refs.embeddedForm.loadData(
            formId,
            "",
            that.campaignData.campaign.id
          );
        } else if (
          isFirstNodeContentType &&
          toNode.formData.contentSelectValue.contentType == "landingPage"
        ) {
          that.render.campaignId = that.campaignData.campaign.id;
          that.render.campaignName = that.campaignData.campaign.campaignName;
          that.render.techId = that.campaignData.qr.techId;
          that.currentNode = toNode;
          await that.getLandingPageData(toNode.formData.contentSelectValue.id);
          that.landingPageDataProcessing();
        }
      }
    },
    onTranslationLanguageSelectedAction(data){
      let that = this;
      if (data && data.selectedLanguage){
        that.selectedLanguage = data.selectedLanguage;
        console.log('CampaignRenderPage selectedLang: ', that.selectedLanguage);
      }
    },
    afterLoadAction(data) {
      let that = this;
      if (data && data.formContent) {
        console.log(data.status);

        that.$nextTick(() => {
          that.render.showed = true;
          that.isLoading = false;
        });
        that.formImageAssetOnload(data.formContent);
      }
    },
    onErrorAction(data) {
      let that = this;
      console.log(data);
      if (data && data.status == "error") {
        that.isLoading = false;
      }
    },
    onSubmitAction(data) {
      let that = this;
      console.log(data);
      if (data && data.status == "submitting") {
        that.isLoading = true;
      }
    },
    afterSubmitAction(data) {
      let that = this;
      if (
        data &&
        data.formId &&
        data.formName &&
        data.formContent &&
        data.formResult &&
        data.formType
      ) {
        that.insertClientRecord("formSubmitted", data.formName, {
          form_content: data.formContent,
          form_id: data.formId
        });
        that.getNextDecision(
          data.formId,
          data.formContent,
          data.formResult,
          data.formAction,
          data.formType
        );
      }
    },
    async registerClientWithForm(formId, formContent, formResult) {
      let that = this;
      let uniqueIdentifiers = [];
      let formCustomFields = {};
      let formEmail = formResult.find(f => f.type == "email"); // main form input 1st priority check if there are no other uniq-iden
      let formResultFiltered = formResult.filter(fr => fr.userData[0]);
      formResultFiltered.map(function(fr) {
          formCustomFields[fr.name] = fr.userData[0];
      });
      formResultFiltered = formResultFiltered.map(function(fr) {
          return {
            name: fr.name,
            userData: [fr.userData[0]]
          };
      });
      //this into forloop(formRes) => Alias => construct data => uniqIden
      let formBody = formResultFiltered;
      const returnedClientId = await that.checkUniqueIdentifier(formBody);
      that.client_id = returnedClientId ? returnedClientId : that.client_id;
      let uniqueIdentified  = returnedClientId ? true : false; // returned client = identified = true
      if (!uniqueIdentified) { // case POST, when client is new and unique
        // new session if client_id have been flushed again by returned user ( submit different uniq_iden by same session client_id )
        const sessionFlushed = await that.lookupClientId(that.client_id);
        if (sessionFlushed) {
          // found existing clientId = have to register new client_id to session
          that.client_id = uuid.v4();
          localStorage.setItem(this.uaipKey, that.client_id);
        }
      }
      let body = {
        email: formEmail || "",
        company: that.company || "",
        customFields: formCustomFields || "",
        scanRecordId: that.campaignData.scanRecordId
      };
      if(!uniqueIdentified){ // POST with new client_id
        body['id'] = that.client_id;
      }else{ // PUT with form submit mode to endpoint request
        body['requestMode'] = 'form submit';
      }
      // insert to table 'client', if there is a new unique-identifier (email have 1st priority of checking > uniq-iden)
      let method = uniqueIdentified ? "PUT" : "POST";
      let pathTemplate = uniqueIdentified
        ? "/clients/" + that.client_id
        : "/clients";
      let additionalParams = {};
      let pathParams = {};
      // console.log(JSON.stringify(body))
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
        .then(function(result) {
          if (result.data.status) {
          } else {
          }
        })
        .catch(function(error) {
            console.log(error)
        });
    },
    async checkUniqueIdentifier(formResult) {
      let method = "POST";
      let pathTemplate = `/clients/identifier`;
      let additionalParams = {};
      let pathParams = {};
      let that = this;
      that.isSubmitted = true;
      return apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams, formResult)
        .then(function(result) {
          if (result.data.data.length > 0) {
            return result.data.data[0].id;
          } else {
            return;
          }
        })
        .catch(function(error) {
          console.log(error)
          return;
        });
    },
    async lookupClientId(client_id) {
      let method = "GET";
      let pathTemplate = `/clients/` + client_id;
      let additionalParams = {};
      let pathParams = {};
      let that = this;
      that.isSubmitted = true;
      return apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          if (result.data.data.length > 0) {
            return true;
          } else {
            return false;
          }
        })
        .catch(function(error) {
          console.log(error)
          return false;
        });
    },
    async getLandingPageData(landingPageId) {
      let method = "GET";
      let pathTemplate = "/landingPages/" + landingPageId;
      let additionalParams = {};
      let pathParams = {};
      let landingPageData = [];
      let that = this;
      await apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          that.landingPageBuilderData = result.data.data.htmlBuilderData;
          return;
        })
        .catch(function(error) {
          console.log(error);
          return null;
        });
    },
    landingPageDataProcessing() {
        // get inner formData by embeddedCode
        let htmlLp = this.landingPageBuilderData.editorHtml;
        let cssLp = this.landingPageBuilderData.formStyle;
        if (htmlLp.lastIndexOf(`<div startForm="#`) > 0) {
          let landingPageFormCode = htmlLp.substring(
            htmlLp.lastIndexOf(`<div startForm="#`) + 17,
            htmlLp.lastIndexOf(`<div startForm="#`) + 17 + 6 // 6 = length of formCode
          );
          if (landingPageFormCode) {
            this.render.formId = htmlLp.substring(
              htmlLp.lastIndexOf(`<div formId"ID-`) + 15,
              htmlLp.lastIndexOf(`<div formId"ID-`) + 15 + 36 // 36 = length of uuid
            );
            this.upperLandingPage = htmlLp.substring(
              0,
              htmlLp.lastIndexOf(
                `<div startForm="#` + landingPageFormCode + `"/>`
              )
            );
            this.lowerLandingPage = htmlLp.substring(
              htmlLp.lastIndexOf(`<div endForm="#` + landingPageFormCode + `"/>`)
            );
            // do get from embeddedFormCode and render it between the rawHtml, embeddedForm in middle then append the html above and below it
            this.$refs.embeddedForm.loadData(
              "",
              landingPageFormCode,
              this.campaignData.campaign.id
            );
          }
        } else {
          this.upperLandingPage = htmlLp;
        }
        this.lpStyle = cssLp;
    },
    async getNextDecision(formId, formContent, formResult, formAction, formType) {
      let that = this;
      let isRegisterForm = false, isRenderNext = false;
      //let form = that.formContents.find(form => form.id == formId);
      if (
        that.currentNode != null &&
        that.currentNode.formData.title == "Content" &&
        (that.currentNode.formData.contentSelectValue.id == formId ||
          (formId &&
            that.currentNode.formData.contentSelectValue.contentType ==
              "landingPage"))
      ) {
        /* Checking form action */
        if (formAction == "Remain at form") {
          let linkDecisionYes = null;
          let linkDecisionNo = null;
          if (
            that.currentNode.decision != undefined &&
            that.currentNode.decision != null
          ) {
            linkDecisionYes = that.currentNode.decision.yes;
            linkDecisionNo = that.currentNode.decision.no;
          }

          // Checking protectCode correct or wrong
          let protectCodeUsageCount = null;
          let decidedDecision = "yes";
          if (that.currentNode.formData.contentSelectValue.formType === "Code" || formType === "Code") {
            let protectCodeField = formResult.find(
              f => f.name == "text-protect-code"
            );
            let protectCodeFieldValue =
              protectCodeField != null && protectCodeField != undefined
                ? protectCodeField.userData[0]
                : null;

            if (
              protectCodeFieldValue != null &&
              that.campaignData.qr.set_protect_codes != null
            ) {
              if (
                protectCodeFieldValue === that.campaignData.qr.set_protect_codes
              ) {
                // Correct protect code
                that.wronglyTypedProtectCode = '';
                isRegisterForm = true;
                decidedDecision = "yes";
                let result = await that.increaseAndGetLatestProtectCodeUsageCount(
                  that.campaignData.qr.companyId,
                  that.campaignData.qr.techId,
                  protectCodeFieldValue
                );
                protectCodeUsageCount = result.protectCodeUsageCount;
                console.log(protectCodeUsageCount);
                if (protectCodeUsageCount == null) {
                  return;
                }
              } else {
                // Wrong protect code
                decidedDecision = "no";
                that.wronglyTypedProtectCode = protectCodeFieldValue;
              }
            }
          } else {
            isRegisterForm = true;
          }

          // Checking the form result data includes at least one yesnogroup field and detect its clicked value (yes/no)
          let yesnogroupFieldInFormResult = formResult.find(f=> f.type === "yesnogroup" && f.userData[0] !== 'NULL');
          if(yesnogroupFieldInFormResult){
            let yesnogroupVal = yesnogroupFieldInFormResult.userData[0];
            decidedDecision = (yesnogroupVal) ? yesnogroupVal : decidedDecision;
          }

          let toNodeId = decidedDecision == "yes" ? linkDecisionYes : linkDecisionNo;
          if (toNodeId != null) {
            let toNode = that.campaignData.campaign.nodes.find(
              n => n.id == toNodeId
            );
            if (toNode) {
              //Check toNode is form or data
              let isToNodeContentType = toNode.formData.title == "Content";
              let isToNodeDataType = toNode.formData.title == "Data";

              if (
                isToNodeDataType &&
                toNode.formData.dataSelectValue.data ===
                  "Verify Code Usage Limit" &&
                (that.currentNode.formData.contentSelectValue.formType === "Code" || formType === "Code")
              ) {
                if (
                  toNode.formData.dataSelectValue.maxUsageLimit > 0 &&
                  protectCodeUsageCount >
                    toNode.formData.dataSelectValue.maxUsageLimit
                ) {
                  // Go to decision no page if it's existed
                  if (toNode.decision && toNode.decision.no != null) {
                    toNode = that.campaignData.campaign.nodes.find(
                      n => n.id == toNode.decision.no
                    );
                    isRenderNext = true;
                  }
                } else {
                  // Decision will be yes, Can go to next page as maxUsageLimit is  0
                  if (toNode.decision && toNode.decision.yes != null) {
                    toNode = that.campaignData.campaign.nodes.find(
                      n => n.id == toNode.decision.yes
                    );
                    isRegisterForm = true
                    isRenderNext = true;
                  }
                }
              }
              if (isToNodeContentType) {
                isRegisterForm = true
                isRenderNext = true;
              }
            }
            await that.registerClientWithForm(formId, formContent, formResult);
            that.renderNextContent(toNode);
          } else {
            // No next decisioin node avaialable
            await that.registerClientWithForm(formId, formContent, formResult);
            isRegisterForm = true
            that.isLoading = false;
            that.showThankYou = true;
          }
          //that.isLoading = false;
        } else {
          that.isLoading = false;
        }
      }
    },
    async renderNextContent(toNode) {
      let that = this;
      this.upperLandingPage = null, this.lowerLandingPage = null, this.lpStyle = null; // reset as rendering next content
      let nextFormId = toNode.formData.contentSelectValue.id;
      let toNodeContentType = toNode.formData.title == "Content";
      if (
        toNodeContentType &&
        toNode.formData.contentSelectValue.contentType == "form"
      ) {
        that.render.formId = nextFormId;
        that.render.campaignId = that.campaignData.campaign.id;
        that.render.campaignName = that.campaignData.campaign.campaignName;
        that.render.techId = that.campaignData.qr.techId;
        that.currentNode = toNode;
        that.$refs.embeddedForm.loadData(
          nextFormId,
          "",
          that.campaignData.campaign.id
        );
      } else if (
        toNodeContentType &&
        toNode.formData.contentSelectValue.contentType == "landingPage"
      ) {
        that.render.campaignId = that.campaignData.campaign.id;
        that.render.campaignName = that.campaignData.campaign.campaignName;
        that.render.techId = that.campaignData.qr.techId;
        that.currentNode = toNode;
        await that.getLandingPageData(toNode.formData.contentSelectValue.id);
        that.landingPageDataProcessing();
      }
    },
    increaseAndGetLatestProtectCodeUsageCount(companyId, techId, protectCode) {
      let that = this;
      let protectCodeUsageCount = null;
      return new Promise(async (resolve, reject) => {
        if (companyId && techId && protectCode) {
          apigClient
            .invokeApi(
              {},
              "/increase-protect-code-usage-count",
              "POST",
              {},
              { companyId: companyId, techId: techId, protectCode: protectCode }
            )
            .then(function(result) {
              if (result.data.status) {
                protectCodeUsageCount = result.data.data;
                resolve(protectCodeUsageCount);
              } else {
                console.log(
                  `Error found from API Endpoint on Form Submit: ${result.data.message}`
                );
                that.errorMsg = "Error! Something went wrong on form submit";
                that.showErrorAlert = true;
                that.isLoading = false;
                reject(protectCodeUsageCount);
              }
            })
            .catch(function(result) {
              console.log("invokeAPI Error on Form submit: " + result);
              that.errorMsg = "Error! Something went wrong on form submit";
              that.showErrorAlert = true;
              that.isLoading = false;
              reject(protectCodeUsageCount);
            });
        }
      });
    },
    formImageAssetOnload(formContents) {
      formContents.forEach(content => {
        if (
          content.type == "Image" &&
          content.shape &&
          content.shape.includes("http")
        ) {
          this.checkAssetOnload(content.shape, content);
        }
      });
    },
    checkAssetOnload(assetUrl, form) {
      let that = this;
      const URL = assetUrl;
      let image = new Image();
      image.src = URL;
      image.onload = function() {
        that.insertClientRecord("assetDownloaded", assetUrl, form);
      };
    },
    insertClientRecord(recordType, recordValue, eventDetails) {
      let body = {
        referrerUrl: this.referrerUrl,
        userAgent: navigator.userAgent,
        client_id: this.client_id,
        client_email:
          this.client_email || `${this.trackingInfo["ip-address"]}@nomail.ypb`,
        location: [
          {
            countryName: this.geolocationCountry
              ? this.trackingInfo["geo-country"]
              : this.trackingInfo["ip-country"]
          },
          {
            cityName: this.geolocationCity
              ? this.trackingInfo["geo-city"]
              : this.trackingInfo["ip-city"]
          },
          {
            latitude: this.geolocationLatitude
              ? this.trackingInfo["geo-latitude"]
              : this.trackingInfo["ip-latitude"]
          },
          {
            longitude: this.geolocationLongitude
              ? this.trackingInfo["geo-longitude"]
              : this.trackingInfo["ip-longitude"]
          }
        ],
        eventDetails: eventDetails
      };
      switch (recordType) {
        case "pageHit":
          body.eventType = "Page hit";
          body.eventName = recordValue; //landing page
          break;
        case "accessedFromIP":
          body.eventType = "Accessed from IP";
          body.eventName = recordValue; //IP address
          break;
        case "assetDownloaded":
          body.eventType = "Asset downloaded";
          body.eventName = recordValue; //Asset onload
          break;
        case "formSubmitted":
          body.eventType = "Form submitted";
          body.eventName = recordValue; //Form submit
          break;
        default:
          break;
      }
      apigClient
        .invokeApi({}, "/clientRecords", "POST", {}, body)
        .then(function(result) {
          if (result.data.status) {
            console.log("inserting to clientRecords done: ", body.eventType);
          } else {
            console.log(
              `Error found from API Endpoint on inserting clientRecord: ${result.data.message}`
            );
          }
        })
        .catch(function(result) {
          console.log("invokeAPI Error on inserting clientRecord: " + result);
        });
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: "Geolocation Message:",
      message: ""
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "Geolocation Message:",
      message: ""
    }
  }
};
</script>

<style scoped>
.thankyou {
  color: #000000;
}

.loader .spinner {
  position: absolute;
  width: 3rem;
  height: 3rem;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.loader .assetUrlImage {
  position: absolute;
  width: 15%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.loader {
  position: fixed;
  background-color: #ffffff;
  opacity: 1;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}
</style>
